import { getSuitCaseData } from '../ducks/selectors';
import { useSelector } from 'react-redux';

export const useGetCaseData = () => {
  const caseItemsData = useSelector(getSuitCaseData);
  return {
    ...caseItemsData,
  };
};
